module.exports = __webpack_public_path__ + "media/images/sec_6-1-ff843acd1c211a14cdfac86f8177f618.png";